<template>
    <ModalComponent
        :name="name"
        title="Descargar resumen de ventas"
        v-on:close="() => close(false)"
    >
        <div v-if="! loading">
            <div class="card-body">                    
                <div class="row">
                    <div class="col-12 col-md-6">
                        <div class="form-group">
                            <label for="del">DEL</label>
                            <input type="date" id="del" placeholder="Del" v-model="fecha_inicio">
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group">
                            <label for="al">AL</label>
                            <input type="date" id="al" placeholder="Al" v-model="fecha_fin">
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form-group">
                            <label for="provincias">Formato</label>
                            <multiselect
                                v-model="formato"
                                placeholder="Formato"
                                label="value"
                                track-by="id"
                                :options="tipos"
                                :multiple="false"
                            ></multiselect>
                        </div>
                        <div class="form-group">
                            <label for="provincias">Teatro</label>
                            <multiselect
                                v-model="teatro"
                                placeholder="Teatro"
                                label="nombre"
                                track-by="id"
                                :options="teatros"
                                :multiple="false"
                            ></multiselect>
                        </div>                                          
                        <div class="form-group">
                            <label for="provincias">Taquillero</label>
                            <multiselect
                                v-model="taquillero"
                                placeholder="Taquillero"
                                label="nombre"
                                track-by="id"
                                :options="taquilleros"
                                :multiple="false"
                            ></multiselect>
                        </div>                                            
                        <div class="mt-4">
                            <Button @click="getInforme()">DESCARGAR</Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <template v-else>
            <div class="card m-0">
                <div class="card-body">                    
                    <div class="row">
                        <h2>Se esta generando el informe, recibirá una notificación para poder descargarlo cuando esté listo.</h2>
                    </div>
                </div>
            </div>
        </template>
    </ModalComponent>
</template>

<script>
import ModalComponent from "@/components/backend/components/ModalComponent";

export default {
    props: ['name', 'teatro_id', 'taquillero_id', 'del', 'al', 'pasado', 'actual', 'teatros', 'taquilleros'],
    data() {
        return {
            loading: false,
            fecha_inicio: null,
            fecha_fin: null,
            pasados: false,
            actuales: false,
            tipos: [
                { value: 'xls' },
                { value: 'pdf' }           
            ],
            formato: { value: 'xls' },
            taquillero: null,
            teatro: null
        }
    },
    created() {
        this.fecha_inicio = this.del;
        this.fecha_fin = this.al;
        this.pasados = this.pasado;
        this.actuales = this.actual;

        if (this.taquillero_id && this.taquilleros) {
            this.taquillero = this.taquilleros.find(taquillero => taquillero.id === this.taquillero_id);
        }

        if (this.teatro_id && this.teatros) {
            this.teatro = this.teatros.find(teatro => teatro.id === this.teatro_id);
        }
    },
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        },
    },
    methods: {
        close() {
            this.loading = false;
            this.$emit('close', this.name);
        },
        getInforme() {
            this.loading = true;
            const params = {
                filters : {
                    fecha_inicio: this.fecha_inicio,
                    fecha_fin: this.fecha_fin,
                    format: this.formato.value,
                    search_teatro_id: this.teatro?.id ?? '',
                    taquillero_id: this.taquillero?.id ?? '', 
                    pasado: this.pasado,
                    actuales: this.actuales,
                },
            };

            if(this.taquillero){
                params.filters.taquillero_id = this.taquillero.id
            }

            this.$store.dispatch(this.config.getVuexAlias("back.events.resumen-ventas.descargar"), params).then(res => {
                this.loading = true
            });
        }
    },
    components: {
        ModalComponent
    }
}
</script>
